export default __webpack_public_path__ + "static/media/quote.0fc8efb5.png";